import './statsFilter.css';
import React from 'react';
import DatePicker from "react-datepicker";
import { listItemStyle, textFieldStyle } from '../../../../utils/consts/styles';
import { Button, MenuItem } from '@mui/material';
import TextField from '@mui/material/TextField';

export const StatsFilter = ({ dateRange, onDateChange, onApply, onReset, academicYear, onAcademicYearChange }) => {
  return (
    <div className="statsFilterBlock">
      <div className="filterLabel">
        <span>
          Диапаозон дат
        </span>
        <DatePicker
          selectsRange={true}
          onChange={onDateChange}
          startDate={dateRange[0]}
          endDate={dateRange[1]}
          showMonthDropdown
          showYearDropdown
          required
          placeholderText="Выберите диапазон дат"
          dropdownMode="select"
          dateFormat="dd.MM.yyyy"
          className="datePickerFilter"
        />
      </div>
      <div className="filterLabel">
        <span>
          Учебный год
        </span>
        <TextField
          type="text" variant="outlined" color="warning" size="small" select className="educationYearFilter"
          value={academicYear} onChange={(e) => onAcademicYearChange(e.target.value)}
          InputLabelProps={textFieldStyle}
        >
          <MenuItem value="23-24">
            <span style={{...listItemStyle, color: 'black'}}>2023-2024</span>
          </MenuItem>
          <MenuItem value="24-25">
            <span style={{...listItemStyle, color: 'black'}}>2024-2025</span>
          </MenuItem>
          <MenuItem value="25-26">
            <span style={{...listItemStyle, color: 'black'}}>2025-2026</span>
          </MenuItem>
          <MenuItem value="26-27">
            <span style={{...listItemStyle, color: 'black'}}>2026-2027</span>
          </MenuItem>
        </TextField>
      </div>
      <div className="filterButtonBlock">
        <Button onClick={onApply} className="filterSaveButton">
          Применить
        </Button>
        <Button onClick={onReset} color="warning" variant="outlined">
          Сбросить
        </Button>
      </div>
    </div>
  );
};
